import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { map } from 'rxjs';
import { JwtService } from 'src/auth/services/jwt.service';
import { Router } from '@angular/router';

export const allowedPortalMatchGuard: CanMatchFn = (route, segments) => {
  const router = inject(Router);
  const jwtService = inject(JwtService);
  const target = segments.length > 0 ? segments[0].path : '';

  if (target) {
    return jwtService.allowedPortals$.pipe(
      map((allowedPortals) => {
        const isAllowed = allowedPortals.some((x) => x.trim().toLowerCase() === target);
        return isAllowed ? true : router.createUrlTree(['/launch']);
      }),
    );
  }

  return true;
};
